import React from 'react';
import { CustomLoadingIcon } from '../../../../supplementary_components/loading_icon';
import styled from 'styled-components';
import { addNotification } from '../../../../supplementary_components/store';

const CurrentLocationContainer = styled.div`
    & > span {
        cursor: default;
        color: var(--gray);
        font-weight: 600;
    }
`;

const CopyableLocation = styled.span`
    cursor: default;
    color: var(--gray);
    font-weight: 600;

    &:hover {
        cursor: pointer;
        color: var(--main-color);
    }
`;

function copyLocationToClipboard(text) {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
        addNotification({ message: 'Location copied', type: 'success' });
    }).catch(() => {
        addNotification({ message: 'Failed to copy location', type: 'alert' });
    });
}

export const MB_CURRENT_LOCATION = ({currentLocation, currentLatLng, initialLocationsLoaded = false}) => {
    const formattedVersion = currentLocation || '-';
    const copyText = currentLatLng || currentLocation;
    return <CurrentLocationContainer>
        {currentLocation ? (
            <CopyableLocation
                role="button"
                tabIndex={0}
                onClick={() => copyLocationToClipboard(copyText)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        copyLocationToClipboard(copyText);
                    }
                }}
            >
                {formattedVersion}
            </CopyableLocation>
        ) : initialLocationsLoaded ? (
            <span>-</span>
        ) : (
            <CustomLoadingIcon height={'1.5rem'} speed={1.0} />
        )}
    </CurrentLocationContainer>;
};

